import { accountSettings } from "../consts/AccountSettings.const";

export const updateLanguageChoice = (languageChoice: string): void => {
    const document = accountSettings.getDocument();
    document.latestModel.language.languageChoice.update({
        value: languageChoice
    });
};
